import namespace from "@rdf-esm/namespace";
const builder = namespace("http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#");
export const strict = builder;
export const loose = builder;